<template>
  <!-- Shows the chosen / saved file name with Change and Remove buttons.
       When there is no file, the normal file input (default slot) is shown.
       "Change" opens a file picker and re-emits the browser `change` event as
       `replace`, so the parent can reuse the same handler as the slotted input. -->
  <div
    v-if="name"
    class="form-control d-flex align-items-center justify-content-between"
  >
    <span class="text-truncate me-2" :title="name">
      <i class="mdi mdi-file-outline me-1"></i>{{ name }}
    </span>
    <span class="d-flex flex-shrink-0 gap-1">
      <button
        type="button"
        class="btn btn-sm btn-outline-secondary"
        :disabled="busy"
        @click="openPicker"
      >
        Change
      </button>
      <button
        type="button"
        class="btn btn-sm btn-outline-danger"
        :disabled="busy"
        @click="$emit('remove')"
      >
        Remove
      </button>
    </span>
    <input
      ref="picker"
      type="file"
      class="d-none"
      tabindex="-1"
      :accept="accept"
      @change="onPick"
    />
  </div>
  <slot v-else />
</template>

<script>
export default {
  name: "FileUploadField",
  props: {
    name: { type: String, default: "" },
    busy: { type: Boolean, default: false },
    accept: {
      type: String,
      default:
        ".docx,.doc,application/pdf,application/vnd.ms-excel,image/jpg,image/jpeg,image/png",
    },
  },
  emits: ["remove", "replace"],
  methods: {
    openPicker() {
      if (this.$refs.picker) this.$refs.picker.click();
    },
    onPick(event) {
      if (!event.target.files || !event.target.files.length) return;
      this.$emit("replace", event); // parent reads event.target.files[0] synchronously
      event.target.value = ""; // allows picking the same file again later
    },
  },
};
</script>